<template>
  <div class="BankCardInfoPop">
    <div class="cardBorder">
      <div class="card">
        <div class="title">{{ $t('lang.UPIandBankCardInfo.UPIInfo') }}</div>
      </div>
    </div>
    <img src="../../assets/images/accountInfo/close.png" alt="" class="close">
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style lang="less" scoped>
.BankCardInfoPop{
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.6);
  //background-color: red;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  .cardBorder{
    background-color: rgb(115,115,115);
    height: 140.833vw;
    width: 86.666vw;
    border-radius: 4.166vw;
    padding: 0.2vw;
    .card{
      background-color: rgb(26,27,26);
      border-radius: 4.166vw;
      height: 100%;
      width: 100%;
      padding: 4.8vw 6.72vw;
      gap: 2vw;
      .title{
        font-size: 5.833vw;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .close{
    height: 4.733vw;
    width: 4.333vw;
    position: absolute;
    top: 183vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BankCardInfoPop/index.vue